import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Formik, Form, Field } from 'formik'

import './css/styles.scss'

import AppClass from './../../../../../js/classes/App'
import DomClass from './../../../../../js/classes/Dom'
import OrderClass from './../../../../../js/classes/Order'

const OrderCallApp = () => {
    const [ isShow, setShow ] = useState(true),
    [ classes, setClasses ] = useState([])

    const closeHandle = () => {
        setShow(false)

        AppClass.setCookie("BITRIX_POPUPS_DISCOUNT_FIRST_SHOW", 'SHOW', {
            expires : new Date((new Date().getTime() + 1000 * 60 * 60 * 24 * 365)),
            path : '/'
        })
    }

    useEffect(() => {
        
    }, [])

    useEffect(() => {
        const _classes = ['happy-order__call']

        if (isShow) {
            _classes.push('happy-order__call_show')
        }

        setClasses(_classes)
    }, [ isShow ])

    return <div className={ classes.join(' ') }>
        <div className="happy-discount-first-order__blackmask" onClick={ closeHandle }></div>

        <div className="happy-discount-first-order__content">
            <span className="happy-discount-first-order__close" onClick={ closeHandle }></span>

           
            <div className="happy-discount-first-order__title">У вас есть скидка на первый заказ!!</div>

            <div className="happy-discount-first-order__text">
                ывфыв фы вфы васфы выфв фыв фыв ыфвфы ывфыв фы вфы васфы выфв фыв фыв ыфвфы ывфыв фы вфы васфы выфв фыв фыв ыфвфы
                ывфыв фы вфы васфы выфв фыв фыв ыфвфы
                ывфыв фы вфы васфы выфв фыв фыв ыфвфыывфыв фы вфы васфы выфв фыв фыв ыфвфыывфыв фы вфы васфы выфв фыв фыв ыфвфы!
            </div>
        </div>
    </div>
}

const isShowPopup = AppClass.getCookie("BITRIX_POPUPS_DISCOUNT_FIRST_SHOW") === 'SHOW'

if (!isShowPopup || 1 === 2) {
    const container = document.getElementById('root-discount-first-order-container')

    if (container) ReactDOM.render(<OrderCallApp />, container)
}